import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  fetchListBeneSuccess,
  fetchListBeneFailure,
  fetchAddBeneProfileSuccess,
  fetchAddBeneProfileFailure,
  fetchAddBeneTemplateSuccess,
  fetchAddBeneTemplateFailure,
  fetchAddBeneTemplateRequest,
} from "./actions";
import { FETCH_ADD_BENE_PROFILE_REQUEST, FETCH_ADD_BENE_TEMPLATE_REQUEST, FETCH_LIST_BENE_REQUEST } from "./actions.type";
import { RESPONSEBASE, TEMPLATE } from "app/shared/services/services-model.type";
import { fetchAddBeneProfileService, fetchAddBeneTemplateService, fetchListBeneService } from "../services/bene.service";
import { FetchAddBeneProfileRequest, FetchAddBeneTemplateRequest, FetchListBeneRequest } from "./types";
import { getErrorMessage } from "app/shared/services/axios";

function* fetchListBeneSaga(action: FetchListBeneRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchListBeneService(action));
    console.log("fetchListBene response: ", response);
    if (response.status === 200) {
      const listBene = response.data.RESPONSEDATA?.TRANSPROFILES;
      yield put(fetchListBeneSuccess(listBene));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchListBeneFailure());
    getErrorMessage(e, false);
  }
}

function* fetchAddBeneProfileSaga(action: FetchAddBeneProfileRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchAddBeneProfileService(action));
    console.log("fetchAddBeneProfile response: ", response);
    if (response.status === 200) {
      const transProfile = response.data.RESPONSEDATA?.TRANSPROFILE;
      yield put(fetchAddBeneProfileSuccess(transProfile));
      const template: TEMPLATE = { ...action.payload?.template, PROFILE_ID: transProfile?.PROFILE_ID };
      yield put(fetchAddBeneTemplateRequest(template));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchAddBeneProfileFailure());
    getErrorMessage(e, false);
  }
}

function* fetchAddBeneTemplateSaga(action: FetchAddBeneTemplateRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchAddBeneTemplateService(action));
    console.log("fetchAddBeneTemplate response: ", response);
    if (response.status === 200) {
      yield put(fetchAddBeneTemplateSuccess());
    }
  } catch (e: any | AxiosError) {
    yield put(fetchAddBeneTemplateFailure());
    getErrorMessage(e, false);
  }
}

function* beneSaga() {
  yield all([takeLatest(FETCH_LIST_BENE_REQUEST, fetchListBeneSaga)]);
  yield all([takeLatest(FETCH_ADD_BENE_PROFILE_REQUEST, fetchAddBeneProfileSaga)]);
  yield all([takeLatest(FETCH_ADD_BENE_TEMPLATE_REQUEST, fetchAddBeneTemplateSaga)]);
}

export default beneSaga;
